(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsWasBoxViewModel', facilityDetailsWasBoxViewModelFactory);

  /** @ngInject */
  function facilityDetailsWasBoxViewModelFactory(washBoxUtils, modelUtils) {
    function FacilityDetailsWasBoxViewModel(washBoxPointJson) {
      this._propertyMappings = {};
      this._propertyMappings[washBoxUtils.FeedReferences.OP_CLEAN_BROJ_SATI_RADA] = 'cleanHours';
      this._propertyMappings[washBoxUtils.FeedReferences.OP_CLEAN_BROJ_MIN_RADA] = 'cleanMinutes';
      this._propertyMappings[washBoxUtils.FeedReferences.OP_VISKTL_BROJ_SATI_RADA] = 'totalWorkingHours';
      this._propertyMappings[washBoxUtils.FeedReferences.OP_VISKTL_RESET_SATI_RADA] = 'serviceWorkingHours';

      if (typeof washBoxPointJson !== 'undefined') {
        this.refresh(washBoxPointJson);
      }
    }

    FacilityDetailsWasBoxViewModel.prototype.destroy = function () {

    };

    FacilityDetailsWasBoxViewModel.prototype.refresh = function (washBoxPointJson) {
      this.pointId = washBoxPointJson.id;
      this.name = washBoxPointJson.name;
      setFeedValue.call(this, washBoxUtils.getFeed(washBoxPointJson, washBoxUtils.FeedReferences.OP_CLEAN_BROJ_SATI_RADA));
      setFeedValue.call(this, washBoxUtils.getFeed(washBoxPointJson, washBoxUtils.FeedReferences.OP_CLEAN_BROJ_MIN_RADA));
      setFeedValue.call(this, washBoxUtils.getFeed(washBoxPointJson, washBoxUtils.FeedReferences.OP_VISKTL_BROJ_SATI_RADA));
      setFeedValue.call(this, washBoxUtils.getFeed(washBoxPointJson, washBoxUtils.FeedReferences.OP_VISKTL_RESET_SATI_RADA));
    };

    FacilityDetailsWasBoxViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsWasBoxViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();
